import React from 'react'
import Header from '../components/Header'
import styled from 'styled-components'
import Hero from '../components/Hero'
import Skills from '../components/Skills'
import Experience from '../components/Experience'
import ProjectSection from '../components/ProjectSection'
import Contact from '../components/Contact'

const Home = () => {
  return (
    <StyledHome>
        <Header/>
        <Hero/>
        <Skills/>
        <Experience/>
        <ProjectSection/>
        <Contact/>
    </StyledHome>
  )
}

export default Home

const StyledHome = styled.div`
    background-color: #FFF5FF;
`